export type ProfileType = "freelancer" | "business";

export const profileFormConfig = {
	freelancer: {
		individualName: {
			label: "First Name",
			placeholder: "Enter your first name",
			tooltip: "Your first name as it should appear on invoices.",
			requiredMessage: "Please enter your first name"
		},

		businessName: {
			label: "Last Name",
			placeholder: "Enter your last name",
			tooltip: "Your last name as it should appear on invoices.",
			requiredMessage: "Please enter your last name"
		},

		website: {
			label: "Portfolio / LinkedIn",
			placeholder: "Enter your portfolio or LinkedIn URL",
			tooltip: "Provide your portfolio, LinkedIn profile, or personal website to help verify your identity.",
			urlError: "URL must start with http:// or https://"
		},

		taxId: {
			label: "National ID Number",
			placeholder: "Enter your national ID number",
			tooltip: "Your government-issued national identification number used for identity verification.",
			requiredMessage: "Please enter your national ID number"
		},

		phone: {
			label: "Phone Number",
			placeholder: "Enter your phone number",
			tooltip: "This phone number will be used to contact you regarding your account.",
			requiredMessage: "Please enter your phone number"
		},

		gender: {
			label: "Gender",
			placeholder: "Select your gender",
			tooltip: "This information will be used for demographic purposes.",
			requiredMessage: "Please select your gender"
		},

		occupation: {
			label: "Occupation",
			placeholder: "Select your occupation",
			tooltip: "This information will be used for demographic purposes.",
			requiredMessage: "Please select your occupation"
		},

		addressLine: {
			label: "Address Line",
			placeholder: "Enter your street address",
			tooltip: "Your residential or professional address that will appear on invoices.",
			requiredMessage: "Please enter your address"
		},

		city: {
			label: "City",
			placeholder: "Enter your city",
			tooltip: "Your city of residence or business operations.",
			requiredMessage: "Please enter your city"
		},

		state: {
			label: "State / Province",
			placeholder: "Enter your state",
			tooltip: "Your state or province of residence.",
			requiredMessage: "Please enter your state"
		},

		postalCode: {
			label: "Postal Code",
			placeholder: "Enter your postal code",
			tooltip: "Your ZIP or postal code.",
			requiredMessage: "Please enter your postal code"
		},

		country: {
			label: "Country",
			tooltip: "Select the country where you reside or operate.",
			requiredMessage: "Please select your country"
		},

		taxDocument: {
			label: "National ID Document",
			tooltip: "Upload your national ID document for identity verification. Accepted formats: PDF, JPG, PNG. Maximum size: 5MB.",
			requiredMessage: "Please upload your national ID document"
		},

		digitalSignature: {
			label: "Digital Signature",
			tooltip: "Create your digital signature. This will appear on invoices you send.",
			requiredMessage: "Please save your digital signature"
		},

		//Below labels are not visible in UI

		businessType: {
			label: "",
			placeholder: "",
			tooltip: "",
			requiredMessage: ""
		},
		email: {
			label: "",
			placeholder: "",
			tooltip: "",
			requiredMessage: "",
			invalidMessage: ""
		},
		logo: {
			label: "",
			tooltip: "",
			requiredMessage: ""
		}
	},

	business: {
		individualName: {
			label: "Individual Name",
			placeholder: "Enter your name",
			tooltip: "Your profile name",
			requiredMessage: "Please enter your name"
		},

		businessName: {
			label: "Business Name",
			placeholder: "Enter legally registered business name",
			tooltip: "Your legally registered business name. This will appear on invoices.",
			requiredMessage: "Please enter your business name"
		},

		businessType: {
			label: "Business Type",
			placeholder: "Select business type",
			tooltip: "Select your business structure.",
			requiredMessage: "Please select your business type"
		},

		website: {
			label: "Website or LinkedIn",
			placeholder: "Provide business website, LinkedIn or Facebook page",
			tooltip: "Help us verify your business. Provide your company website or LinkedIn or Facebook page.",
			urlError: "URL must start with http:// or https://"
		},

		taxId: {
			label: "Tax ID",
			placeholder: "EIN, GST, or VAT number this appears on your invoices",
			tooltip:
				"For businesses, your government-issued tax identification number: EIN, GST, or VAT. For freelancers: your personal national ID number.",
			requiredMessage: "Please enter your tax ID"
		},

		phone: {
			label: "Business Phone",
			placeholder: "Primary business contact",
			tooltip: "We'll use this to contact you about your account. Select proper country code.",
			requiredMessage: "Please enter your business phone number"
		},

		email: {
			label: "Business Email",
			placeholder: "Enter an email that will receive invoice notifications",
			tooltip: "Invoices and payment notifications will be sent here.",
			requiredMessage: "Business email is required",
			invalidMessage: "Enter a valid business email"
		},

		addressLine: {
			label: "Business Address Line",
			placeholder: "Enter business street address",
			tooltip: "Your official business address. This will appear on invoices.",
			requiredMessage: "Please enter your business address line"
		},

		city: {
			label: "Business Town/City",
			placeholder: "Enter business city",
			tooltip: "City where your business is located.",
			requiredMessage: "Please enter your business town/city"
		},

		state: {
			label: "Business State / Province",
			placeholder: "Enter business state",
			tooltip: "State or province where your business operates.",
			requiredMessage: "Please enter your business state"
		},

		postalCode: {
			label: "Business Postal Code",
			placeholder: "Enter business postal code",
			tooltip: "ZIP or postal code for your business location.",
			requiredMessage: "Please enter your business postal code"
		},

		country: {
			label: "Country",
			tooltip: "The country where your business is registered.",
			requiredMessage: "Please select your business country"
		},

		taxDocument: {
			label: "Tax Registration",
			tooltip: "Upload your tax registration certificate. Accepted formats: PDF, JPG, PNG. Max 5MB.",
			requiredMessage: "Please upload your tax registration document"
		},

		logo: {
			label: "Logo",
			tooltip: "Your company logo for invoices. PNG with transparent background works best. Recommended size: at least 200px wide.",
			requiredMessage: "Please upload your company logo"
		},

		digitalSignature: {
			label: "Digital Signature",
			tooltip: "Create signature. This will be used on invoices you send with a datetime stamp.",
			requiredMessage: "Please save the authorized signature"
		},
		gender: {
			label: "",
			placeholder: "",
			tooltip: "",
			requiredMessage: ""
		},
		occupation: {
			label: "",
			placeholder: "",
			tooltip: "",
			requiredMessage: ""
		}
	}
};
